import React from 'react'
import { Modal } from 'antd-mobile'
import { useTranslation } from 'react-i18next'
import { ChevronLeft } from '@yy/one-icon'
import styles from './index.module.less'

interface GuideModalProps {
  banner: React.ReactNode
  showBack?: boolean
  backFn?: () => any
  visible?: boolean
}

export const GuideModal: React.FC<GuideModalProps> = (props) => {
  const { banner, showBack = false, backFn, children, visible = false } = props
  const { t } = useTranslation()

  return (
    <Modal
      className={styles.root}
      visible={visible}
      content={
        <div className={styles.modal}>
          <div className={styles.header}>
            {banner}
            {showBack ? (
              <a onClick={backFn} className={styles.close}>
                <ChevronLeft />
                {t('dashbord.guide.dismissmodal')}
              </a>
            ) : null}
          </div>
          <div className={styles.body}>{children}</div>
        </div>
      }
    />
  )
}
